import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { NetworkStatusService } from '../services/network-status/network-status.service';

function isNetworkError(err: unknown): boolean {
  if (err instanceof HttpErrorResponse) {
    if (err.status === 0) return true;
    const msg = (err.message || err.error?.message || '').toLowerCase();
    if (
      msg.includes('err_internet_disconnected') ||
      msg.includes('failed to fetch') ||
      msg.includes('networkerror') ||
      msg.includes('network request failed')
    ) {
      return true;
    }
  }
  return false;
}

/**
 * Interceptor que detecta errores de red (sin conexión) y muestra un toast de advertencia.
 * No reemplaza el manejo de errores de cada pantalla; solo informa al usuario.
 */
export const networkErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const networkStatus = inject(NetworkStatusService);

  return next(req).pipe(
    catchError((err: unknown) => {
      if (isNetworkError(err)) {
        networkStatus.showOfflineToast();
      }
      return throwError(() => err);
    })
  );
};
